module.exports = __webpack_public_path__ + "img/logo.20b614c0.png";